import Vue from 'vue';
import PageBase from '@glittr/frontend-core/src/core/v2/app/pageBase';
import GetDynamicFormDefinitionRequestViewModel from '@glittr/frontend-core/src/services/v1/viewModel/request/DynamicForm/GetDynamicFormDefinitionRequestViewModel';
import DynamicFormPayloadResourceViewModel from '@glittr/frontend-core/src/services/v1/viewModel/resource/DynamicFormPayloadResourceViewModel';
import DynamicFormPostRequestViewModel from '@glittr/frontend-core/src/services/v1/viewModel/resource/DynamicFormPostRequestViewModel';
import DynamicFormDefinitionResourceViewModel from '@glittr/frontend-core/src/services/v1/viewModel/resource/DynamicFormDefinitionResourceViewModel';
import GetDynamicFormPayloadRequestViewModel from '@/src/services/v1/viewModel/request/DynamicForm/GetDynamicFormPayloadRequestViewModel';
import IPDynamicFormGroupDisplay from '@glittr/frontend-core/src/components/p-dynamic-form/IPDynamicFormGroupDisplay';

export default class CampaignEventVM extends PageBase {
  // must be set from outside
  appSystemKey: string = '';
  formDefinitionId: string = '';
  contactId: string = '';

  formDefinition: DynamicFormDefinitionResourceViewModel = new DynamicFormDefinitionResourceViewModel();
  isLoading: boolean = true;
  isSubmitting: boolean = false;
  isSubmitted: boolean = false;

  groupDisplayOverrides: IPDynamicFormGroupDisplay[] | undefined = undefined;

  mockpayloadstring = '{"appSystemKey":"OM","form":{"fields":[{"id":"e5122a42-b273-4923-bef5-17644a0cdc96","values":[]},{"id":"950f5512-d721-44ac-9e1d-42205cbddccc","values":[]},{"id":"3470e713-8408-47c3-bbb8-8078e63023e6","values":[]},{"id":"8b142335-7684-4d5f-9e1e-99d175e45438","values":[]},{"id":"40025423-3b9d-4238-b19c-43b3e1940ee4","values":[]},{"id":"0ce37fc4-a537-4b47-a71f-2997603f1bc1","values":[]},{"id":"6ce2bef5-345b-47a4-a6bb-6d98d5d41555","values":[]},{"id":"cba7e23a-a3d4-48e2-adca-74712ef14b15","values":[]},{"id":"8d38c170-405d-4fa9-940f-d7b58286513b","values":["Hans Muster"]},{"id":"58d715ca-de5d-4520-91ef-0f7584562848","values":[]},{"id":"1ac4b801-4160-4eca-b3ee-59cf22dc0567","values":[]},{"id":"89402825-4cfe-4316-9ed8-d33e6931b797","values":[]},{"id":"f67530e4-7e8e-4102-baba-96e4b10a7ebc","values":[]},{"id":"b903ced2-0a12-4ce9-9b88-de6943ebd96f","values":[]},{"id":"6468ae4e-e6e8-4a08-8a98-e9bac85942c7","values":[]},{"id":"1c653b99-2124-4d6f-ae36-4e60ac6814c7","values":[]},{"id":"a847da42-c943-4f6d-981a-709abc480428","values":[]},{"id":"22c2f0f3-74ee-488e-a021-ad8cfbdff3e9","values":[]},{"id":"060de1bf-2e62-45bf-8ed1-2a1392dab69e","values":[]},{"id":"193bcd79-fd56-4615-9938-b40e132e3b92","values":[]},{"id":"9d59f306-d5d2-4c5e-a698-f4f7f9a11b22","values":[]}],"contact":{"countryIso2":"CH","salutation":1,"firstName":"Hans","lastName":"Muster","street":"Oberdorf","city":"Obstalden","eMail":"hans.muster@email.ch","phoneNumber":"+41763191199","postalCode":"8758"},"definitionId":"149f637e-2d03-47d6-904e-4f799da54615","languageIso2":"de"}}';

  error: any;
  formSummary: any = {};
  formPayload = new DynamicFormPayloadResourceViewModel();
  async initialize(): Promise<void> {
    try {
      await this.loadFormDefinition();
      await this.initializeFormPayload();
      this.updateGroupDisplayOverrides();
    } catch (error) {
      this.error = error;
    } finally {
      this.isLoading = false;
    }
  }
  async initializeFormPayload() {
    const req = new GetDynamicFormPayloadRequestViewModel();
    req.formDefinitionId = this.formDefinitionId;
    req.contactId = this.contactId;
    req.appSystemKey = this.appSystemKey;
    // extract the dto and inject into new viewmodel to have a 'real' viewmodel that can be sent to backend again
    const backendPayloadVM = await Vue.$service.api.dynamicForm.getDynamicFormPayload(req);
    const backendPayloadDTO = backendPayloadVM.toDTO();
    const formPayloadVM = new DynamicFormPayloadResourceViewModel().fromDTO(backendPayloadDTO);
    this.formPayload = formPayloadVM;
  }
  async loadFormDefinition() {
    const req = new GetDynamicFormDefinitionRequestViewModel();
    req.appSystemKey = this.appSystemKey;
    req.id = this.formDefinitionId;
    this.formDefinition = await Vue.$service.api.core.dynamicForm.getDynamicFormDefinition(req);
  }
  updateGroupDisplayOverrides() {
    const partnerContactGroupKey = Vue.$config.values['widget-dynamicform-partner-contact-group-key'];
    if (!partnerContactGroupKey) {
      return;
    }
    // Find all field ids from the partner contact group
    const partnerFieldIds = this.formDefinition.fields.find((f) => f.key === partnerContactGroupKey)?.items.map((i) => i.id);
    // If any field contains a value expand the group
    const hasPartner = this.formPayload.fields.some((f) => partnerFieldIds?.some((id) => f.id.toLowerCase() === id.toLowerCase() && f.values.length >= 1));
    this.groupDisplayOverrides = [
      {
        key: partnerContactGroupKey,
        isAccordion: true,
        isExpanded: hasPartner,
      },
    ];
  }

  // submit
  get canSubmitForm() { return !this.isSubmitting && this.formDefinition.initalized; }
  async submitForm() {
    this.isSubmitting = true;
    try {
      if (!this.formPayload.validate()) {
        this.isSubmitting = false;
        return;
      }
      this.formPayload.definitionId = this.formDefinitionId!;
      this.formPayload.languageIso2 = Vue.$translation.get() ?? Vue.$config.values['language-default'];
      this.formPayload.contactId = undefined;
      const req = new DynamicFormPostRequestViewModel().fromModel({
        appSystemKey: this.appSystemKey,
        form: this.formPayload,
      });
      await Vue.$service.api.core.dynamicForm.postDynamicForm(req);
      this.isSubmitted = true;
    } catch (error: any) {
      this.error = error;
    }
    this.isSubmitting = false;
  }
}
